import http from '@/lib/http'
import { useQuery } from '@tanstack/react-query'

export interface Flag {
  post_author: string
  post_modified: string
  hash: string
  title: string
  description: string | null
  visibility: string
}

export const useGetFlags = () => {
  return useQuery({
    queryKey: ['getFlags'],
    staleTime: Number.POSITIVE_INFINITY,
    queryFn: () => http.get<Record<string, Flag>, Record<string, Flag>>('/prescriber/flags')
  })
}
